import React, { FC } from 'react'
import { RouteComponentProps } from '@reach/router'
import { EventListContainer } from '../components/EventList'

export const Events: FC<RouteComponentProps> = () => {
  return <EventListContainer />
}

Events.displayName = 'EventsRoute'
